import { gql } from '@apollo/client'

export default gql(`
    mutation adminForgotPassword( $email: String!) {
        adminForgotPassword(
            email: $email
        ) {
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
